import React from 'react';
import FeedAgenzie from './components/FeedAgenzie';

const Feed = () => {
  return (
    <div className="min-h-screen">
      <FeedAgenzie />
    </div>
  );
};

export default Feed;